import {FlowEnum} from 'presentation/pages/private/booking/constants';

const CHANGE_PLAN_LOCATION_FLOW = 'CHANGE_PLAN';

type ChangePlanLocationFlow = typeof CHANGE_PLAN_LOCATION_FLOW;
type FlowEnumWithoutProfile = Exclude<FlowEnum, FlowEnum.PROFILE>;

type FlowTypeEnum = Exclude<
	FlowEnum,
	FlowEnum.PROFILE | FlowEnum.HEALTH_GUIDE | FlowEnum.ODONTO_GUIDE
>;

type FlowTypeEnumWithoutAuth = Exclude<FlowTypeEnum, FlowEnum.AUTHORIZATIONS>;

type LocationSelectionFlowEnum = FlowEnumWithoutProfile | ChangePlanLocationFlow;

export {CHANGE_PLAN_LOCATION_FLOW};
export type {
	FlowTypeEnum,
	FlowTypeEnumWithoutAuth,
	FlowEnumWithoutProfile,
	ChangePlanLocationFlow,
	LocationSelectionFlowEnum,
};
